import type { RouteRecordRaw } from 'vue-router';

export const usersRoute: RouteRecordRaw = {
  path: '/users',
  name: 'Users',
  component: () => import('./pages/UsersPage.vue'),
  meta: { layout: 'main', superadmin: true },
};

export const userEditRoute: RouteRecordRaw = {
  path: '/users/:id',
  name: 'UserEdit',
  component: () => import('./pages/UserEditPage.vue'),
  meta: { layout: 'main', superadmin: true },
};
